/**
 * MMP Metadata
 * This is a API for MMP Metadata
 *
 * The version of the OpenAPI document: 1.0.0-oas3
 * Contact: st116848@stud.uni-stuttgart.de.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

import { Artifact } from '../model/artifact';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable({
  providedIn: 'root'
})
export class ArtifactService {

    protected basePath = 'https://localhost:8080/v1/metadata';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();
    public encoder: HttpParameterCodec;

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {

        if (configuration) {
            this.configuration = configuration;
            this.configuration.basePath = configuration.basePath || basePath || this.basePath;

        } else {
            this.configuration.basePath = basePath || this.basePath;
        }
        this.encoder = this.configuration.encoder || new CustomHttpParameterCodec();
    }



    /**
     * adds an artifact
     * Adds an artifact
     * @param execution The execution\&#39;s id
     * @param artifact Artifact item to add
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addArtifact(execution: string, artifact?: Artifact, observe?: 'body', reportProgress?: boolean): Observable<Artifact>;
    public addArtifact(execution: string, artifact?: Artifact, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Artifact>>;
    public addArtifact(execution: string, artifact?: Artifact, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Artifact>>;
    public addArtifact(execution: string, artifact?: Artifact, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (execution === null || execution === undefined) {
            throw new Error('Required parameter execution was null or undefined when calling addArtifact.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<Artifact>(`${this.configuration.basePath}/experiments/runs/executions/${encodeURIComponent(String(execution))}/artifacts`,
            artifact,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * list of artifacts
     * Return list of artifacts
     * @param execution The execution\&#39;s id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getArtifactsByExecution(execution: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Artifact>>;
    public getArtifactsByExecution(execution: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Artifact>>>;
    public getArtifactsByExecution(execution: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Artifact>>>;
    public getArtifactsByExecution(execution: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (execution === null || execution === undefined) {
            throw new Error('Required parameter execution was null or undefined when calling getArtifactsByExecution.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Artifact>>(`${this.configuration.basePath}/experiments/runs/executions/${encodeURIComponent(String(execution))}/artifacts`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * list of artifacts
     * Return list of artifacts
     * @param experiment The experiemnt\&#39;s id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getArtifactsByExperiment(experiment: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Artifact>>;
    public getArtifactsByExperiment(experiment: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Artifact>>>;
    public getArtifactsByExperiment(experiment: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Artifact>>>;
    public getArtifactsByExperiment(experiment: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (experiment === null || experiment === undefined) {
            throw new Error('Required parameter experiment was null or undefined when calling getArtifactsByExperiment.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Artifact>>(`${this.configuration.basePath}/experiments/${encodeURIComponent(String(experiment))}/artifacts`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * return artifact by id
     * Return one artifact
     * @param artifact The artifact\&#39;s id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getArtifactsById(artifact: string, observe?: 'body', reportProgress?: boolean): Observable<Artifact>;
    public getArtifactsById(artifact: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Artifact>>;
    public getArtifactsById(artifact: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Artifact>>;
    public getArtifactsById(artifact: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (artifact === null || artifact === undefined) {
            throw new Error('Required parameter artifact was null or undefined when calling getArtifactsById.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Artifact>(`${this.configuration.basePath}/experiments/runs/executions/artifacts/${encodeURIComponent(String(artifact))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * list of artifacts
     * Return list of artifacts
     * @param run The run\&#39;s id
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getArtifactsByRun(run: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Artifact>>;
    public getArtifactsByRun(run: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Artifact>>>;
    public getArtifactsByRun(run: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Artifact>>>;
    public getArtifactsByRun(run: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (run === null || run === undefined) {
            throw new Error('Required parameter run was null or undefined when calling getArtifactsByRun.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected !== undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }


        return this.httpClient.get<Array<Artifact>>(`${this.configuration.basePath}/experiments/runs/${encodeURIComponent(String(run))}/artifacts`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
